<template>
  <div class="menu-qx-page">
    <div class="menu-qx-header">
      <div class="menu-qx-header-inner">
        <div class="menu-qx-back" @click="xqesc">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </div>
        <div class="menu-qx-title">{{ pickda[pickxb].ddxq }}</div>
        <div class="menu-qx-placeholder"></div>
      </div>
    </div>

    <div class="menu-qx-content">
      <div class="title_sd">{{$lang[pickxb].l139}}</div>

      <div class="menu-qx-section">

        <div class="menu-qx-goods-list">
          <div class="menu-qx-goods-item" v-for="(item, index) in list" :key="index">
            <div class="menu-qx-goods-thumb">
              <img @error="imageLoad2(index)" :src="$lujin + '/Data/' + ShopID + '/GoodsPic/' + item.GoodsID + '.jpg'" alt="goods">
              <div class="menu-qx-goods-placeholder" v-if="!item.GoodsID">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </div>
            </div>
            <div class="menu-qx-goods-info">
              <div class="menu-qx-goods-name">
                <span v-if="WXLangGoodsxb == 0">{{ item.Goods }}</span>
                <span v-else-if="WXLangGoodsxb == 1">{{ item.TwoGoods }}</span>
                <span v-else>{{ item.ThreeGoods }}</span>
              </div>
              <div class="menu-qx-goods-meta">
                <span class="menu-qx-goods-time">{{ pickda[pickxb].xdsj }}: {{ item.OpItemsTime }}</span>
              </div>
              <div class="menu-qx-goods-bottom">
                <div class="menu-qx-goods-price">
                  <span class="menu-qx-price-symbol">{{MoneySymbol}}</span>
                  <span class="menu-qx-price-value">{{ item.SellPrice }}</span>
                </div>
                <div class="menu-qx-goods-quantity">
                  <span class="menu-qx-quantity-badge">{{ item.Qua }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="cartOrderVisible" class="menu-cart-del-mask" @click="closeCartOrderConfirm">
      <div class="menu-cart-del-dialog" @click.stop>
        <div class="menu-cart-del-title">{{$lang[pickxb].l17}}</div>
        <div class="menu-cart-del-text">{{ cartOrderConfirmText }}</div>
        <div class="menu-cart-del-actions">
          <div v-if="!cartOrderTipMode" class="menu-cart-del-btn cancel" @click="closeCartOrderConfirm">{{$lang[pickxb].l16}}</div>
          <div class="menu-cart-del-btn ok" @click="confirmCartOrder">{{ cartOrderTipMode ? $lang[pickxb].l12 : $lang[pickxb].l15 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MenuQx',
    data() {
      return {
        pickxb: 0,
        sheet: {},
        pickindex: 0,
        SheetID: 0,
        DeskID: 0,
        WXLangGoodsxb: 0,
        Phone: 0,
        TradeId: '',
		MoneySymbol:"",
        ShopID: 0,
        cartOrderVisible: false,
        cartOrderTipMode: false,
        cartOrderConfirmText: '',
        list: [{
          SheetID: 0,
          GoodsID: 1001,
          SellPrice: 0,
          OpItemsTime: "00:00"
        }],
		Foodlist: [
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "台號", on2: "預計應收", on3: "明細", on4: "人數", on5: "預計人均", on6: "確定", on7: "請下單後查看" },
		  { on1: "Desk", on2: "Receivable", on3: "Detailed", on4: "Number of people", on5: "Per capita", on6: "Determine", on7: "Please check after placing the order" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "Número de estación", on2: "Créditos previstos", on3: "Detalles", on4: "Número de personas", on5: "Se espera que per cápita", on6: "Determinar", on7: "Por favor, haga un pedido y vea." },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "T", on2: "prijs", on3: "detail", on4: "Aantal personen", on5: "Per persoon", on6: "goed", on7: "Controleer na het plaatsen van de bestelling" },
		  { on1: "Numéro de station", on2: "Créances attendues", on3: "Détails", on4: "Nombre de personnes", on5: "Moyenne attendue par habitant", on6: "Confirmer", on7: "Veuillez vérifier après avoir passé la commande" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "テーブル番号", on2: "合計(税込)", on3: "詳細", on4: "ご利用人数", on5: "割り勘", on6: "確定", on7: "データがありません" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "Station Nr.", on2: "Voraussichtlicher Erl?s", on3: "Aufschlüsselung", on4: "Personenzahl", on5: "Voraussichtlicher Pro-Kopf-Betrag", on6: "Best?tigen", on7: "Bitte nach Bestellung einsehen" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "台号", on2: "预计应收", on3: "明细", on4: "人数", on5: "预计人均", on6: "确定", on7: "请下单后查看" },
		  { on1: "Nomor stasiun", on2: "Perkiraan piutang", on3: "Rincian", on4: "Jumlah orang", on5: "Perkiraan per kapita", on6: "Konfirmasi", on7: "Silakan periksa setelah penempatan pesanan" },
		  { on1: "หมายเลขสถานี", on2: "ประมาณการลูกหนี้", on3: "รายละเอียด", on4: "จำนวนคน", on5: "ประมาณการต่อหัว", on6: "แน่นอน", on7: "กรุณาตรวจสอบหลังจากทำการสั่งซื้อ" },
		  { on1: "Αριθμός σταθμού", on2: "Εκτιμώμενες απαιτήσεις", on3: "Καθέκαστα", on4: "Αριθμός ατόμων", on5: "Εκτιμώμενο κατά κεφαλήν", on6: "Σίγουρος", on7: "Ελέγξτε μετά την τοποθέτηση της παραγγελίας" },
		  { on1: "postaja št.", on2: "Ocenjene terjatve", on3: "Podrobnosti", on4: "Oseba(-e)", on5: "Predvideno na prebivalca", on6: "OK", on7: "Prosimo, preverite po naročilu." },
		  { on1: "Station number", on2: "Estimated receivable", on3: "detail", on4: "Person(s)", on5: "Projected Per Capita", on6: "OK", on7: "Please check after ordering." },
		  { on1: "Platforma nömrəsi", on2: "Gözlənilən debitor borcları", on3: "Təfərrüatlar", on4: "İnsanların sayı", on5: "Adambaşına düşən gözlənilən", on6: "Əlbəttə", on7: "Sifariş verdikdən sonra yoxlayın." },
		  { on1: "စာရင်းနံပါတ်", on2: "မျှော်မှန်းထားသော တောင်းခံမှု", on3: "အသေးစိတ်", on4: "လူအရေအတွက်", on5: "တစ်ဦးချင်းစီမျှော်မှန်းထားသော တောင်းခံမှု", on6: "အဆင်ပြေသည်", on7: "" },
		  { on1: "masa no", on2: "beklenen tahsil", on3: "ayrıntı", on4: "kişi sayısı", on5: "beklenen kişi başına", on6: "onayla", on7: "sipariş verdiğinizde kontrol edebilirsiniz" },
		  { on1: "Хоолны ширээ захиал", on2: "Хүлээгдэж буй авлага", on3: "Дэлгэрэнгүй мэдээлэл", on4: "Хүмүүсийн тоо", on5: "Нэг хүнд ногдох тооц", on6: "Тэгэлгүй яахав", on7: "Захиалгаа өгсний дараа шалгана уу." },
		],
        pickda: [
          { fh: "返回", ddxq: "订单详情", xdsj: "下单时间", ddh: "订单号", spxx: '商品信息', bz: '备注' },
          { fh: "返回", ddxq: "訂單詳情", xdsj: "下單時間", ddh: "訂單號", spxx: '商品信息', bz: '備註' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "إرجاع", ddxq: "تفاصيل الطلب", xdsj: "وقت الطلب", ddh: "رقم الطلب", spxx: 'معلومات المنتج', bz: 'ملاحظة' },
          { fh: "ដកថយ", ddxq: "ព័ត៌មានលម្អិត", xdsj: "ពេលវេលាបញ្ជា", ddh: "លេខ​លំដាប់", spxx: 'ព័ត៌មាន​អំពី​ផលិតផល', bz: 'ចំណាំ' },
          { fh: "Volver", ddxq: "Detalles del pedido", xdsj: "Hora del pedido", ddh: "No. de pedido", spxx: 'Detalles del producto', bz: 'note' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "Terug", ddxq: "Bestel details", xdsj: "Bestel tijd", ddh: "Bestelling nummer", spxx: 'Productdetails', bz: 'Opmerking' },
          { fh: "Retour", ddxq: "Détails de la commande", xdsj: "Heure de la commande", ddh: "Numéro de commande", spxx: "Informations sur le produit", bz: "Remarques" },
          { fh: "return", ddxq: "dettagli dell'ordine", xdsj: "dettagli dell'ordine", ddh: "numero d'ordine", spxx: 'Informazioni sui prodotti', bz: 'Nota' },
          { fh: "戻り", ddxq: "注文履歴", xdsj: "オーダー時間", ddh: "伝票番号", spxx: '商品内訳[セルフオーダーのみ]', bz: '備考' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "Zurück", ddxq: "Kasse", xdsj: "Bestellzeit", ddh: "Bestellnummer", spxx: 'Produktinformationen', bz: 'Bemerkung' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "wrócić", ddxq: "zamówienia", xdsj: "Czas na złożenie zamówienia", ddh: "Numer zamówienia", spxx: 'Informacje o produkcie', bz: 'uwaga' },
          { fh: "return", ddxq: "details", xdsj: "Place the order of time", ddh: "The order number", spxx: 'Commodity information', bz: 'note' },
          { fh: "Pengembalian", ddxq: "Detail pesanan", xdsj: "Waktu pemesanan", ddh: "Nomor pesanan", spxx: 'Informasi produk', bz: 'Keterangan' },
          { fh: "กลับ", ddxq: "รายละเอียดการสั่งซื้อ", xdsj: "เวลาสั่ง", ddh: "หมายเลขคำสั่งซื้อ", spxx: 'ข้อมูลผลิตภัณฑ์', bz: 'หมายเหตุ' },
          { fh: "απόδοση", ddxq: "Στοιχεία παραγγελίας", xdsj: "Ώρα παραγγελίας", ddh: "Αριθμός παραγγελίας", spxx: 'Πληροφορίες προϊόντος', bz: 'Παρατήρηση' },
          { fh: "Nazaj", ddxq: "Podrobnosti o naročilu", xdsj: "Čas naročila", ddh: "Številka naročila", spxx: 'Informacije o izdelku', bz: 'Opomba' },
          { fh: "Back", ddxq: "Order Details", xdsj: "Order Time", ddh: "Order №", spxx: 'Commodity information', bz: 'Notes' },
          { fh: "qayıtmaq", ddxq: "Kassa", xdsj: "Sifariş vaxtı", ddh: "Sifariş nömrəsi", spxx: 'Məhsul Məlumatı', bz: 'Qeyd' },
          { fh: "ပြန်လည်", ddxq: "စာရင်းအချက်အလက်", xdsj: "နောက်စာရင်းအချိန်", ddh: "စာရင်းနံပါတ်", spxx: 'ကုန်ပစ္စည်းသတင်းအချက်အလက်', bz: 'မှတ်ချက်' },
          { fh: "Geri Dön", ddxq: "Sipariş Detayı", xdsj: "Sipariş Zamanı", ddh: "Sipariş Numarası", spxx: 'Ürün Bilgisi', bz: 'Not' },
          { fh: "буцах", ddxq: "Захиалгын дэлгэрэнгү", xdsj: "Захиалсан цаг", ddh: "Захиалгын дугаар", spxx: "Бүтээгдэхүүний мэдээ", bz: "Тайлбар" },
        ],
      }
    },
    mounted() {
      var that = this
      const shopId = this.$route.query.ShopID || this.$route.query.Shopid
      if (localStorage.getItem(shopId + 'pickxb'))
        this.pickxb = localStorage.getItem(shopId + 'pickxb');
      if (localStorage.getItem(shopId + 'pickindex'))
        this.pickindex = localStorage.getItem(shopId + 'pickindex')
      if (localStorage.getItem(shopId + 'WXLangGoodsxb'))
        this.WXLangGoodsxb = localStorage.getItem(shopId + 'WXLangGoodsxb')
      this.ShopID = shopId
      this.DeskID = this.$route.query.DeskID || this.$route.query.id || ''
      this.SheetID = this.$route.query.SheetID || ''
      this.Phone = this.$route.query.Phone || ""
      try {
        this.TradeId = String(localStorage.getItem(this.ShopID + '_pendingPayTradeId') || '')
      } catch (e) {}
	  this.axios.post(this.$lujin + '/api/Default/Parameter?ShopID=' + this.ShopID).then((res) => {
	  	console.log(res)
		if (res.data && res.data.data && res.data.data[0] && res.data.data[0].MoneySymbol) {
		  this.MoneySymbol = res.data.data[0].MoneySymbol
		}
	  })
      Promise.resolve(this.handleRouteSheetState())
        .finally(() => {
		  that.loadDetailList(0)
		  setTimeout(()=>{
			that.loadDetailList(1)
		  },5000)
        })
    },
    methods: {
      getUpdateSheetStateDoneKey(sheetId) {
        const sheet = String(sheetId || '').trim()
        if (!sheet || !this.ShopID) {
          return ''
        }
        return this.ShopID + '_updateSheetStateDone_' + sheet
      },
      isUpdateSheetStateDone(sheetId) {
        const key = this.getUpdateSheetStateDoneKey(sheetId)
        if (!key) {
          return false
        }
        try {
          return !!localStorage.getItem(key)
        } catch (e) {}
        return false
      },
      markUpdateSheetStateDone(sheetId) {
        const key = this.getUpdateSheetStateDoneKey(sheetId)
        if (!key) {
          return
        }
        try {
          localStorage.setItem(key, String(Date.now()))
        } catch (e) {}
      },
      cleanupUpdateSheetStateDoneFlags() {
        if (!this.ShopID) {
          return
        }
        try {
          const prefix = this.ShopID + '_updateSheetStateDone_'
          const expireMs = 7 * 24 * 60 * 60 * 1000
          const now = Date.now()
          for (let i = localStorage.length - 1; i >= 0; i--) {
            const k = localStorage.key(i)
            if (!k || k.indexOf(prefix) !== 0) {
              continue
            }
            const raw = localStorage.getItem(k)
            const t = Number(raw)
            if (!isFinite(t) || now - t > expireMs) {
              localStorage.removeItem(k)
            }
          }
        } catch (e) {}
      },
      clearPendingPayState() {
        if (!this.ShopID) {
          return
        }
        try {
          localStorage.removeItem(this.ShopID + '_pendingPayUrl')
          localStorage.removeItem(this.ShopID + '_pendingPayToken')
          localStorage.removeItem(this.ShopID + '_pendingPayTradeId')
          localStorage.removeItem(this.ShopID + '_pendingPayAmount')
          localStorage.removeItem(this.ShopID + '_pendingPayAccount')
          localStorage.removeItem(this.ShopID + '_pendingPaySheetID')
        } catch (e) {}
      },
      async handleRouteSheetState() {
        const sheetId = String(this.SheetID || '').trim()
        if (!sheetId || !this.ShopID) {
          return
        }
        if (this.isUpdateSheetStateDone(sheetId)) {
          return
        }
        let pendingTradeId = ''
        let pendingAmount = ''
        let pendingAccount = ''
        try {
          pendingTradeId = String(localStorage.getItem(this.ShopID + '_pendingPayTradeId') || '').trim()
        } catch (e) {}
        try {
          this.cleanupUpdateSheetStateDoneFlags()
          if (pendingTradeId) {
            const payRes = await this.axios.post(this.$lujin + '/api/YabandPay/PayQuery', {
              ShopID: this.ShopID,
              Amount:"",
              trade_id: pendingTradeId,
              account: ''
            })
            if (!(payRes && payRes.data && payRes.data.Info === 'paid')) {
              return
            }
          }
          const res = await this.axios.post(this.$lujin + "/api/Default/UpdateSheetState", {
            SheetID: sheetId,
            ShopID: this.ShopID,
            trad_id: pendingTradeId
          })
          const row = res && res.data ? res.data : {}
          const code = row && row.code !== undefined ? row.code : row.Code
          if (!(row.result || row.Result || row.state || row.State || Number(code) === 0)) {
            throw new Error(row.msg || row.Msg || '订单状态更新失败')
          }
          this.markUpdateSheetStateDone(sheetId)
          this.clearPendingPayState()
		  console.log("参数1"+sheetId)
		  console.log("参数2"+this.ShopID)
		  console.log("参数3"+pendingTradeId)
        } catch (e) {
          this.showOrderTip((e && e.message) ? e.message : '订单状态更新失败')
        }
      },
      loadDetailList(bt) {
        this.axios.get(this.$lujin + "/api/Default/cha_mx?DeskID=" + this.DeskID + "&ShopID=" + this.ShopID)
          .then((res) => {
            console.log(res)
            var sz = res.data.data.Table
            if (!sz || sz.length === 0) {
			  if(bt){
				this.showOrderTip(this.Foodlist[this.pickxb].on7)
			  }
              return
            }
            for (var i in sz) {
              sz[i].OpItemsTime = sz[i].OpItemsTime.replace('T', ' ');
              sz[i].OpItemsTime = sz[i].OpItemsTime.slice(10, 19)
            }
            this.list = sz
          })
      },
      imageLoad2(index) {
        const img = document.querySelectorAll('.menu-qx-goods-thumb img')[index]
        if (img) {
          img.src = '../static/images/zwtp.png'
        }
      },
      xqesc: function() {
        this.$router.go(-1)
      },
      showOrderTip(text) {
        this.cartOrderTipMode = true
        this.cartOrderConfirmText = (text || '').toString()
        this.cartOrderVisible = true
      },
      closeCartOrderConfirm() {
        this.cartOrderVisible = false
      },
      confirmCartOrder() {
        if (this.cartOrderTipMode) {
          this.closeCartOrderConfirm()
          return
        }
        this.closeCartOrderConfirm()
      },
    },
  }
</script>

<style scoped>
.menu-qx-page {
  min-height: 100vh;
  background: #0d1117;
}

.menu-qx-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(16, 21, 30, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.title_sd{
	width:90%;
	margin:0 auto;
	font-size:18px;
	color:orangered;
}
.menu-qx-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 16px;
}

.menu-qx-back {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.menu-qx-back:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.menu-qx-title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.menu-qx-placeholder {
  width: 36px;
}

.menu-qx-content {
  padding-top: 60px;
}

.menu-qx-info-card {
  margin: 12px;
  background: rgba(22, 27, 34, 0.8);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.menu-qx-info-title {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.menu-qx-info-row {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.menu-qx-info-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
}

.menu-qx-info-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f04e05;
  flex-shrink: 0;
}

.menu-qx-info-text {
  flex: 1;
  min-width: 0;
}

.menu-qx-info-label {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  margin-bottom: 2px;
}

.menu-qx-info-value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-qx-section {
  margin: 12px;
}

.menu-qx-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.menu-qx-section-icon {
  color: #f04e05;
}

.menu-qx-section-title {
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  font-weight: 600;
}

.menu-qx-goods-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-qx-goods-item {
  display: flex;
  background: rgba(22, 27, 34, 0.8);
  border-radius: 14px;
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  transition: all 0.2s ease;
}

.menu-qx-goods-item:active {
  transform: scale(0.98);
  background: rgba(22, 27, 34, 1);
}

.menu-qx-goods-thumb {
  width: 96px;
  height: 72px;
  border-radius: 5px;
  overflow: hidden;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.04);
  position: relative;
}

.menu-qx-goods-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.menu-qx-goods-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.2);
}

.menu-qx-goods-info {
  flex: 1;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.menu-qx-goods-name {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.menu-qx-goods-meta {
  margin: 4px 0;
}

.menu-qx-goods-time {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
}

.menu-qx-goods-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu-qx-goods-price {
  display: flex;
  align-items: baseline;
}

.menu-qx-price-symbol {
  color: #f04e05;
  font-size: 13px;
  font-weight: 700;
}

.menu-qx-price-value {
  color: #f04e05;
  font-size: 18px;
  font-weight: 700;
}

.menu-qx-goods-quantity {
  display: flex;
  align-items: center;
}

.menu-qx-quantity-badge {
  background: rgba(240, 78, 5, 0.15);
  color: #f04e05;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
}

.menu-cart-del-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 92;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .24rem;
  box-sizing: border-box;
}

.menu-cart-del-dialog {
  width: 100%;
  max-width: 5.8rem;
  border-radius: .24rem;
  background: #1a1d24;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 .2rem .5rem rgba(0, 0, 0, 0.38);
  padding: .28rem .28rem .22rem;
  box-sizing: border-box;
}

.menu-cart-del-title {
  color: #fff;
  font-size: .32rem;
  line-height: .4rem;
  font-weight: 700;
  text-align: center;
}

.menu-cart-del-text {
  margin-top: .16rem;
  color: rgba(255, 255, 255, 0.84);
  font-size: .28rem;
  line-height: .4rem;
  text-align: center;
}

.menu-cart-del-actions {
  margin-top: .24rem;
  display: flex;
  justify-content: flex-end;
  gap: .16rem;
}

.menu-cart-del-btn {
  height: .72rem;
  line-height: .72rem;
  padding: 0 .34rem;
  border-radius: .72rem;
  font-size: .3rem;
  font-weight: 700;
  box-sizing: border-box;
}

.menu-cart-del-btn.cancel {
  color: rgba(255, 255, 255, 0.72);
  background: rgba(255, 255, 255, 0.08);
}

.menu-cart-del-btn.ok {
  color: #fff;
  background: linear-gradient(135deg, #f04e05 0%, #ff6b35 100%);
}

</style>



// WEBPACK FOOTER //
// src/components/MenuQx.vue